import { useQuery } from "@tanstack/react-query";

import type { PlanDto } from "~/data/subscription/plan.dto";

import { getPlans } from "~/data/subscription/subscription.service";

import { Button } from "../shared/button";

export function Plans() {
  const { data, isLoading, isError, error } = useQuery<PlanDto[], Error>({
    queryKey: ["plans"],
    queryFn: () => getPlans("sua_chave_aqui"),
  });

  if (isError) {
    console.error("Erro ao carregar os planos:", error);
  }

  return (
    <div className="flex flex-col items-center mt-2 mb-5">
      {isLoading ? (
        <div>Carregando planos...</div>
      ) : isError ? (
        <div>Erro ao carregar os planos.</div>
      ) : (
        <>
          <span className="text-sm font-semibold mb-2.5">
            Assine a plataforma
          </span>

          {/* Grid de planos */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
            {data?.map((plan) => (
              <div
                key={plan.id}
                className="bg-white p-6 rounded-lg shadow-lg text-center w-64 mb-5"
              >
                <button
                  className={`text-white text-xl font-semibold mb-2 px-5 rounded ${
                    plan.recurrency === "mensal"
                      ? "bg-primary2"
                      : plan.recurrency === "anual"
                      ? "bg-secondary"
                      : plan.recurrency === "semestral"
                      ? "bg-secondary-2"
                      : ""
                  }`}
                >
                  {plan.name}*
                </button>
                <ul className="mt-4 space-y-2 text-xs text-primary-1 font-bold">
                  <li className="flex justify-between">
                    Valor*{" "}
                    <span className="text-black font-semibold">
                      R${plan.value}
                    </span>
                  </li>
                  <li className="flex justify-between">
                    Modelo:{" "}
                    <span className="text-black font-semibold">
                      {plan.recurrency}
                    </span>
                  </li>
                  <li className="flex justify-between">
                    Checklist:{" "}
                    <span className="text-black font-semibold">Ilimitado</span>
                  </li>
                  <li className="flex justify-between">
                    Benefícios:{" "}
                    <span className="text-black font-semibold">
                      Feedback Completo
                    </span>
                  </li>
                </ul>
                <p className="mt-4 text-xs text-black font-bold">
                  * Válido por{" "}
                  {plan.recurrency === "mensal"
                    ? "1 mês"
                    : plan.recurrency === "anual"
                    ? "1 ano"
                    : "6 meses"}
                </p>
                <Button
                  className="mt-4 w-full bg-primary2 px-5 py-3"
                  variant="primary-1"
                >
                  Assinar
                </Button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
